import {Component, Input, OnInit} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-find-sample-modal',
    templateUrl: './find-sample-modal.component.html',
    styleUrls: ['./find-sample-modal.component.less'],
    standalone: false
})
export class FindSampleModalComponent implements OnInit {
  constructor(public modalRef: BsModalRef) { }

  ngOnInit() {
  }

}
